import * as Command from '../Command/Command.js'
import * as Dialog from './Dialog.js'

// prettier-ignore
export const Commands =  {
  'Dialog.alert': Dialog.alert,
  'Dialog.close': Dialog.close,
  'Dialog.prompt': Dialog.prompt,
  'Dialog.showErrorDialogWithOptions': Dialog.showErrorDialogWithOptions,
}
